export const useDagschoothoogteHeight = () => {
  const getDagschoothoogteHeight = (doorHeight: number): number => {
    if (doorHeight <= 2064) return 940;
    if (doorHeight <= 2269) return 1040;
    if (doorHeight <= 2421) return 1240;
    if (doorHeight <= 2505) return 1425;
    if (doorHeight <= 2520) return 1440;
    if (doorHeight <= 2535) return 1455;
    if (doorHeight <= 2550) return 1470;
    if (doorHeight <= 2565) return 1485;
    if (doorHeight <= 2580) return 1500;

    return 1515; // Default value
  };

  return { getDagschoothoogteHeight };
};
